export default "__VITE_ASSET__atzRoBvM__"